import React, { useState, useEffect } from 'react';
import { fetchGoldPrice } from '../services/goldApiService';
import AdSenseAd from '../components/AdSenseAd';
import './GoldPrices.css';

const GoldPrices = () => {
  const [goldPrices, setGoldPrices] = useState({});
  const [selectedCountry, setSelectedCountry] = useState('INR');
  const [error, setError] = useState('');

  const countries = [
    { code: 'INR', name: 'Indian Rupee', symbol: '₹' },
    { code: 'USD', name: 'US Dollar', symbol: '$' },
    { code: 'EUR', name: 'Euro', symbol: '€' },
    { code: 'GBP', name: 'British Pound', symbol: '£' },
    { code: 'AED', name: 'UAE Dirham', symbol: 'د.إ' },
    { code: 'AUD', name: 'Australian Dollar', symbol: 'A$' },
    { code: 'CAD', name: 'Canadian Dollar', symbol: 'C$' },
    { code: 'CHF', name: 'Swiss Franc', symbol: 'Fr' },
    { code: 'CNY', name: 'Chinese Yuan', symbol: '¥' },
    { code: 'HKD', name: 'Hong Kong Dollar', symbol: 'HK$' },
    { code: 'JPY', name: 'Japanese Yen', symbol: '¥' },
    { code: 'MYR', name: 'Malaysian Ringgit', symbol: 'RM' },
    { code: 'NZD', name: 'New Zealand Dollar', symbol: 'NZ$' },
    { code: 'SGD', name: 'Singapore Dollar', symbol: 'S$' },
    { code: 'THB', name: 'Thai Baht', symbol: '฿' },
    { code: 'ZAR', name: 'South African Rand', symbol: 'R' }
  ];

  useEffect(() => {
    const fetchPrices = async () => {
      try {
        const data = await fetchGoldPrice(selectedCountry);
        setGoldPrices({
          [selectedCountry]: data
        });
      } catch (error) {
        console.error('Error fetching gold prices:', error);
        setError('Failed to fetch current gold prices. Please try again later.');
      }
    };

    fetchPrices();
    const interval = setInterval(fetchPrices, 60000); // Update every minute
    return () => clearInterval(interval);
  }, [selectedCountry]);

  const getCurrencySymbol = () => {
    const country = countries.find(c => c.code === selectedCountry);
    return country ? country.symbol : '₹';
  };

  return (
    <div className="gold-prices-page">
      <div className="live-price-section">
        <h2>Live Gold Price (ozt)</h2>
        
        <AdSenseAd 
          slot="prices-top" 
          format="auto" 
          style={{ margin: '20px auto', maxWidth: '728px' }}
        />

        <div className="currency-selector">
          <select
            value={selectedCountry}
            onChange={(e) => setSelectedCountry(e.target.value)}
          >
            {countries.map(country => (
              <option key={country.code} value={country.code}>
                {country.name}
              </option>
            ))}
          </select>
        </div>
        <p className="current-price">
          {goldPrices[selectedCountry]?.price 
            ? `${getCurrencySymbol()}${goldPrices[selectedCountry].price.toFixed(2)} per troy ounce` 
            : 'Loading...'}
        </p>
        <p className="price-per-gram">
          {goldPrices[selectedCountry]?.price 
            ? `(${getCurrencySymbol()}${(goldPrices[selectedCountry].price / 31.1035).toFixed(2)} per gram)` 
            : ''}
        </p>
        <p className="last-updated">
          {goldPrices[selectedCountry]?.timestamp 
            ? `Last updated: ${new Date(goldPrices[selectedCountry].timestamp).toLocaleString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: true
              })}` 
            : ''}
        </p>
      </div>

      <AdSenseAd 
        slot="prices-middle" 
        format="auto" 
        style={{ margin: '20px auto', maxWidth: '728px' }}
      />

      <div className="market-info">
        <h3>Gold Market Information</h3>
        <div className="info-grid">
          <div className="info-item">
            <h4>Gold Price Factors</h4>
            <ul>
              <li>Global economic conditions</li>
              <li>Inflation rates</li>
              <li>Currency fluctuations</li>
              <li>Central bank policies</li>
              <li>Market demand and supply</li>
            </ul>
          </div>
          <div className="info-item">
            <h4>Gold Investment Benefits</h4>
            <ul>
              <li>Hedge against inflation</li>
              <li>Portfolio diversification</li>
              <li>Safe haven asset</li>
              <li>Long-term value preservation</li>
              <li>Liquidity in global markets</li>
            </ul>
          </div>
          <div className="info-item">
            <h4>Gold Purity Standards</h4>
            <ul>
              <li>24K (99.9% pure)</li>
              <li>22K (91.6% pure)</li>
              <li>18K (75% pure)</li>
              <li>14K (58.3% pure)</li>
              <li>10K (41.7% pure)</li>
            </ul>
          </div>
        </div>
      </div>

      <AdSenseAd 
        slot="prices-bottom" 
        format="auto" 
        style={{ margin: '20px auto', maxWidth: '728px' }}
      />

      {error && <div className="error-message">{error}</div>}
    </div>
  );
};

export default GoldPrices; 